/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics$1 = function (d, b) {
  extendStatics$1 =
    Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array &&
      function (d, b) {
        d.__proto__ = b
      }) ||
    function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]
    }
  return extendStatics$1(d, b)
}

function __extends$1(d, b) {
  extendStatics$1(d, b)
  function __() {
    this.constructor = d
  }
  d.prototype =
    b === null ? Object.create(b) : ((__.prototype = b.prototype), new __())
}

var __assign = function () {
  __assign =
    Object.assign ||
    function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i]
        for (var p in s)
          if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
      }
      return t
    }
  return __assign.apply(this, arguments)
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P
      ? value
      : new P(function (resolve) {
          resolve(value)
        })
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value))
      } catch (e) {
        reject(e)
      }
    }
    function rejected(value) {
      try {
        step(generator['throw'](value))
      } catch (e) {
        reject(e)
      }
    }
    function step(result) {
      result.done
        ? resolve(result.value)
        : adopt(result.value).then(fulfilled, rejected)
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next())
  })
}

function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1]
        return t[1]
      },
      trys: [],
      ops: [],
    },
    f,
    y,
    t,
    g
  return (
    (g = { next: verb(0), throw: verb(1), return: verb(2) }),
    typeof Symbol === 'function' &&
      (g[Symbol.iterator] = function () {
        return this
      }),
    g
  )
  function verb(n) {
    return function (v) {
      return step([n, v])
    }
  }
  function step(op) {
    if (f) throw new TypeError('Generator is already executing.')
    while (_)
      try {
        if (
          ((f = 1),
          y &&
            (t =
              op[0] & 2
                ? y['return']
                : op[0]
                ? y['throw'] || ((t = y['return']) && t.call(y), 0)
                : y.next) &&
            !(t = t.call(y, op[1])).done)
        )
          return t
        if (((y = 0), t)) op = [op[0] & 2, t.value]
        switch (op[0]) {
          case 0:
          case 1:
            t = op
            break
          case 4:
            _.label++
            return { value: op[1], done: false }
          case 5:
            _.label++
            y = op[1]
            op = [0]
            continue
          case 7:
            op = _.ops.pop()
            _.trys.pop()
            continue
          default:
            if (
              !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
              (op[0] === 6 || op[0] === 2)
            ) {
              _ = 0
              continue
            }
            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
              _.label = op[1]
              break
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1]
              t = op
              break
            }
            if (t && _.label < t[2]) {
              _.label = t[2]
              _.ops.push(op)
              break
            }
            if (t[2]) _.ops.pop()
            _.trys.pop()
            continue
        }
        op = body.call(thisArg, _)
      } catch (e) {
        op = [6, e]
        y = 0
      } finally {
        f = t = 0
      }
    if (op[0] & 5) throw op[1]
    return { value: op[0] ? op[1] : void 0, done: true }
  }
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function (d, b) {
  extendStatics =
    Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array &&
      function (d, b) {
        d.__proto__ = b
      }) ||
    function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]
    }
  return extendStatics(d, b)
}

function __extends(d, b) {
  extendStatics(d, b)
  function __() {
    this.constructor = d
  }
  d.prototype =
    b === null ? Object.create(b) : ((__.prototype = b.prototype), new __())
}

var MyError = /** @class */ (function (_super) {
  __extends(MyError, _super)
  function MyError(message) {
    var _newTarget = this.constructor
    var _this = _super.call(this, message) || this
    Object.setPrototypeOf(_this, _newTarget.prototype)
    return _this
  }
  return MyError
})(Error)

var string = {
  check: function (value) {
    return typeof value === 'string'
  },
}
var number = {
  check: function (value) {
    return typeof value === 'number'
  },
}
var boolean = {
  check: function (value) {
    return typeof value === 'boolean'
  },
}
var nil = {
  check: function (value) {
    return value === null
  },
}
var unknown = {
  check: function (value) {
    return true
  },
}
function literal(str) {
  return {
    check: function (value) {
      return value === str
    },
  }
}
function any(checkers) {
  return {
    check: function (value) {
      return checkers.some(function (checker) {
        return checker.check(value)
      })
    },
  }
}
function nullable(checker) {
  return {
    check: function (value) {
      return value === null || checker.check(value)
    },
  }
}
function array(checker) {
  return {
    check: function (value) {
      return (
        Array.isArray(value) &&
        value.every(function (it) {
          return checker.check(it)
        })
      )
    },
  }
}
function object(properties) {
  return {
    check: function (value) {
      if (typeof value !== 'object' || value === null) return false
      return Object.keys(properties).every(function (key) {
        var unescapedKey = unescapePropertyName(key)
        if (has(value, unescapedKey)) {
          // properties の keys を取得しているので properties に key は絶対に存在する
          var checkerOrFunction = properties[key]
          if (isChecker(checkerOrFunction)) {
            return checkerOrFunction.check(value[unescapedKey])
          }
          var lazyChecker = checkerOrFunction()
          if (isChecker(lazyChecker)) {
            return lazyChecker.check(value[unescapedKey])
          } else {
            return false
          }
        } else {
          return isOptionalProperty(key)
        }
      })
    },
  }
}
function isChecker(target) {
  return (
    typeof target === 'object' &&
    target !== null &&
    has(target, 'check') &&
    typeof target.check === 'function'
  )
}
function isOptionalProperty(propertyName) {
  var _a
  return (
    ((_a = propertyName.match(/[^?]?(?:\?\?)*(\?)?$/)) === null || _a === void 0
      ? void 0
      : _a[1]) === '?'
  )
}
function unescapePropertyName(propertyName) {
  var _a, _b, _c
  var match = propertyName.match(/^(.*?[^?]?)((?:\?\?)*)\??$/)
  if (match === null) {
    return propertyName
  }
  var head = (_a = match[1]) !== null && _a !== void 0 ? _a : ''
  var questionMarks =
    (_c =
      (_b = match[2]) === null || _b === void 0
        ? void 0
        : _b.replace(/\?\?/g, '?')) !== null && _c !== void 0
      ? _c
      : ''
  return '' + head + questionMarks
}
// https://github.com/microsoft/TypeScript/issues/21732#issuecomment-663994772
function has(target, property) {
  return property in target
}

var typistJson = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  string: string,
  number: number,
  boolean: boolean,
  nil: nil,
  unknown: unknown,
  literal: literal,
  any: any,
  nullable: nullable,
  array: array,
  object: object,
  isOptionalProperty: isOptionalProperty,
  unescapePropertyName: unescapePropertyName,
})

var InternalError = (function (_super) {
  __extends$1(InternalError, _super)
  function InternalError() {
    return (_super !== null && _super.apply(this, arguments)) || this
  }
  return InternalError
})(MyError)
var HttpError = (function (_super) {
  __extends$1(HttpError, _super)
  function HttpError(statusCode, body) {
    var _this = _super.call(this, 'HTTP Error: ' + statusCode) || this
    _this.statusCode = statusCode
    _this.body = body
    return _this
  }
  return HttpError
})(InternalError)
var ApiError = (function (_super) {
  __extends$1(ApiError, _super)
  function ApiError(errorCode, errorMessage) {
    var _this = _super.call(this, 'API Error: ' + errorCode) || this
    _this.errorCode = errorCode
    _this.errorMessage = errorMessage
    return _this
  }
  return ApiError
})(InternalError)
var JsonError = (function (_super) {
  __extends$1(JsonError, _super)
  function JsonError(json) {
    return _super.call(this, 'JSON Error: ' + JSON.stringify(json)) || this
  }
  return JsonError
})(InternalError)

var AnyflowError = (function (_super) {
  __extends$1(AnyflowError, _super)
  function AnyflowError(type) {
    var _this = _super.call(this, 'AnyflowError: ' + type) || this
    _this.type = type
    return _this
  }
  return AnyflowError
})(MyError)

var SolutionWizardImpl = (function () {
  function SolutionWizardImpl(iframe, tokenManager, wizardRoot) {
    var _this = this
    this.listeners = new Set()
    this.destroyed = false
    this.handleMessage = function (event) {
      if (event.origin !== new URL(_this.wizardRoot).origin) {
        return
      }
      if (CompleteMessageChecker.check(event.data)) {
        var solutionId_1 = event.data.solutionId
        _this.listeners.forEach(function (listener) {
          listener('completed', solutionId_1)
        })
      } else if (CancelMessageChecker.check(event.data)) {
        var solutionId_2 = event.data.solutionId
        _this.listeners.forEach(function (listener) {
          listener('canceled', solutionId_2)
        })
      }
    }
    this.iframe = iframe
    this.tokenManager = tokenManager
    window.addEventListener('message', this.handleMessage)
    this.wizardRoot = wizardRoot
  }
  SolutionWizardImpl.prototype.destroy = function () {
    this.destroyed = true
    this.iframe = null
    this.tokenManager = null
    this.listeners.clear()
    window.removeEventListener('message', this.handleMessage)
  }
  SolutionWizardImpl.prototype.load = function (solutionId) {
    return __awaiter(this, void 0, void 0, function () {
      var url, _a
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            this.assertNotDestroyed()
            if (this.tokenManager === null) {
              throw new Error('tokenManager is null.')
            }
            _a =
              this.wizardRoot +
              '/solutions/' +
              encodeURIComponent(solutionId) +
              '?jwt='
            return [4, this.tokenManager.getToken()]
          case 1:
            url = _a + _b.sent()
            this.replaceUrl(url)
            this.listeners.forEach(function (listener) {
              return listener('loaded', solutionId)
            })
            return [2]
        }
      })
    })
  }
  SolutionWizardImpl.prototype.unload = function () {
    this.assertNotDestroyed()
    this.replaceUrl('about:blank')
  }
  SolutionWizardImpl.prototype.replaceUrl = function (url) {
    if (this.iframe === null) {
      throw new Error('iframe is null.')
    }
    var win = this.iframe.contentWindow
    if (win === null) {
      throw new Error('iframe.contentWindow is null')
    } else {
      win.location.replace(url)
    }
  }
  SolutionWizardImpl.prototype.addListener = function (listener) {
    this.assertNotDestroyed()
    this.listeners.add(listener)
  }
  SolutionWizardImpl.prototype.removeListener = function (listener) {
    this.assertNotDestroyed()
    this.listeners.delete(listener)
  }
  SolutionWizardImpl.prototype.assertNotDestroyed = function () {
    if (this.destroyed) {
      throw new AnyflowError('wizard_already_destroyed')
    }
  }
  return SolutionWizardImpl
})()
var CompleteMessageChecker = typistJson.object({
  type: typistJson.literal('complete'),
  solutionId: typistJson.string,
})
var CancelMessageChecker = typistJson.object({
  type: typistJson.literal('cancel'),
  solutionId: typistJson.string,
})

var POLLING_INTERVAL_MS = 5 * 1000
var AnyflowSDKImpl = (function () {
  function AnyflowSDKImpl(apiClient, tokenManager, wizardRoot) {
    this.destroyed = false
    this.jobPollingTimers = new Map()
    this.wizardInstances = new Set()
    this.apiClient = apiClient
    this.tokenManager = tokenManager
    this.wizardRoot = wizardRoot
  }
  AnyflowSDKImpl.prototype.getSolution = function (solutionId) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, solutionJson, solutionInstanceJson, lastJobId, jobJson, _b
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            this.assertNotDestroyed()
            return [
              4,
              Promise.all([
                this.apiClient.getSolution(solutionId),
                this.apiClient.getSolutionInstance(solutionId),
              ]).catch(defaultErrorHandler),
            ]
          case 1:
            ;(_a = _c.sent()),
              (solutionJson = _a[0]),
              (solutionInstanceJson = _a[1])
            lastJobId =
              solutionInstanceJson === null || solutionInstanceJson === void 0
                ? void 0
                : solutionInstanceJson.last_job_id
            if (!(lastJobId === null || lastJobId === undefined)) return [3, 2]
            _b = undefined
            return [3, 4]
          case 2:
            return [
              4,
              this.apiClient.getJob(lastJobId).catch(defaultErrorHandler),
            ]
          case 3:
            _b = _c.sent()
            _c.label = 4
          case 4:
            jobJson = _b
            if (solutionJson === undefined) {
              return [2, undefined]
            }
            return [
              2,
              {
                id: solutionJson.id,
                name: solutionJson.name,
                description: solutionJson.description,
                state:
                  solutionInstanceJson === undefined
                    ? 'not_installed'
                    : solutionInstanceJson.is_enabled
                    ? 'enabled'
                    : 'disabled',
                latestJob:
                  jobJson === undefined ? undefined : createJob(jobJson),
              },
            ]
        }
      })
    })
  }
  AnyflowSDKImpl.prototype.enableSolution = function (solutionId) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.assertNotDestroyed()
            return [
              4,
              this.apiClient
                .enableSolutionInstance(solutionId)
                .catch(function (error) {
                  if (error instanceof ApiError) {
                    if (error.errorCode === 'solution_not_found') {
                      throw new AnyflowError('solution_not_found')
                    }
                    if (error.errorCode === 'instance_not_found') {
                      throw new AnyflowError('solution_not_installed')
                    }
                  }
                  throw error
                })
                .catch(defaultErrorHandler),
            ]
          case 1:
            _a.sent()
            return [2]
        }
      })
    })
  }
  AnyflowSDKImpl.prototype.disableSolution = function (solutionId) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.assertNotDestroyed()
            return [
              4,
              this.apiClient
                .disableSolutionInstance(solutionId)
                .catch(function (error) {
                  if (error instanceof ApiError) {
                    if (error.errorCode === 'solution_not_found') {
                      throw new AnyflowError('solution_not_found')
                    }
                    if (error.errorCode === 'instance_not_found') {
                      throw new AnyflowError('solution_not_installed')
                    }
                  }
                  throw error
                })
                .catch(defaultErrorHandler),
            ]
          case 1:
            _a.sent()
            return [2]
        }
      })
    })
  }
  AnyflowSDKImpl.prototype.runSolution = function (solutionId) {
    return __awaiter(this, void 0, void 0, function () {
      var jobJson
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.assertNotDestroyed()
            return [
              4,
              this.apiClient
                .runSolutionInstance(solutionId)
                .catch(function (error) {
                  if (error instanceof ApiError) {
                    if (error.errorCode === 'not_manual_trigger') {
                      throw new AnyflowError('solution_not_runnable')
                    }
                    if (error.errorCode === 'solution_not_found') {
                      throw new AnyflowError('solution_not_found')
                    }
                    if (error.errorCode === 'instance_not_found') {
                      throw new AnyflowError('solution_not_installed')
                    }
                  }
                  throw error
                })
                .catch(defaultErrorHandler),
            ]
          case 1:
            jobJson = _a.sent()
            return [2, createJob(jobJson)]
        }
      })
    })
  }
  AnyflowSDKImpl.prototype.getJob = function (jobId) {
    return __awaiter(this, void 0, void 0, function () {
      var jobJson
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.assertNotDestroyed()
            return [4, this.apiClient.getJob(jobId).catch(defaultErrorHandler)]
          case 1:
            jobJson = _a.sent()
            if (jobJson === undefined) {
              return [2, undefined]
            }
            return [2, createJob(jobJson)]
        }
      })
    })
  }
  AnyflowSDKImpl.prototype.observeJob = function (jobId, callback) {
    var _this = this
    this.assertNotDestroyed()
    var jobState = undefined
    var polling = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var jobJson, timer
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 2, , 3])
              return [4, this.apiClient.getJob(jobId)]
            case 1:
              jobJson = _a.sent()
              if (jobJson === undefined) {
                return [2]
              }
              if (jobState !== jobJson.state) {
                callback('state_changed', createJob(jobJson))
                jobState = jobJson.state
              }
              if (jobJson.state === 'running') {
                timer = window.setTimeout(polling, POLLING_INTERVAL_MS)
                this.saveTimer(jobId, callback, timer)
              }
              return [3, 3]
            case 2:
              _a.sent()
              return [3, 3]
            case 3:
              return [2]
          }
        })
      })
    }
    polling()
  }
  AnyflowSDKImpl.prototype.unobserveJob = function (jobId, callback) {
    this.assertNotDestroyed()
    var timer = this.deleteTimer(jobId, callback)
    if (timer !== undefined) {
      window.clearTimeout(timer)
    }
  }
  AnyflowSDKImpl.prototype.createWizard = function (iframe) {
    this.assertNotDestroyed()
    var wizard = new SolutionWizardImpl(
      iframe,
      this.tokenManager,
      this.wizardRoot
    )
    this.wizardInstances.add(wizard)
    return wizard
  }
  AnyflowSDKImpl.prototype.destroy = function () {
    this.wizardInstances.forEach(function (it) {
      return it.destroy()
    })
    this.clearAllTimers()
    this.jobPollingTimers.clear()
    this.destroyed = true
  }
  AnyflowSDKImpl.prototype.assertNotDestroyed = function () {
    if (this.destroyed) {
      throw new AnyflowError('sdk_already_destroyed')
    }
  }
  AnyflowSDKImpl.prototype.saveTimer = function (jobId, callback, timer) {
    var pollingTimerMap = this.jobPollingTimers.get(jobId)
    if (pollingTimerMap === undefined) {
      var newPollingTimerMap = new Map()
      newPollingTimerMap.set(callback, timer)
      this.jobPollingTimers.set(jobId, newPollingTimerMap)
    } else {
      pollingTimerMap.set(callback, timer)
    }
  }
  AnyflowSDKImpl.prototype.deleteTimer = function (jobId, callback) {
    var pollingTimerMap = this.jobPollingTimers.get(jobId)
    if (pollingTimerMap === undefined) {
      return undefined
    }
    var timer = pollingTimerMap.get(callback)
    if (timer === undefined) {
      return undefined
    }
    pollingTimerMap.delete(callback)
    if (pollingTimerMap.size === 0) {
      this.jobPollingTimers.delete(jobId)
    }
    return timer
  }
  AnyflowSDKImpl.prototype.clearAllTimers = function () {
    this.jobPollingTimers.forEach(function (timersMap) {
      timersMap.forEach(function (timer) {
        window.clearTimeout(timer)
      })
    })
  }
  return AnyflowSDKImpl
})()
function createJob(jobJson) {
  return {
    id: jobJson.id,
    state: jobJson.state,
    startedAt: createDate(jobJson.started_at),
    finishedAt:
      jobJson.finished_at === null
        ? undefined
        : createDate(jobJson.finished_at),
    errorMessage:
      jobJson.error_reason === null ? undefined : jobJson.error_reason,
  }
}
function createDate(timestamp) {
  var d = new Date()
  d.setTime(timestamp)
  return d
}
function defaultErrorHandler(error) {
  if (error instanceof ApiError) {
    switch (error.errorCode) {
      case 'invalid_token':
        throw new AnyflowError('token_invalid')
      case 'unknown':
        throw new AnyflowError('unknown')
    }
  }
  if (error instanceof InternalError) {
    throw new AnyflowError('unknown')
  }
  throw error
}

var SolutionJson = typistJson.object({
  id: typistJson.string,
  name: typistJson.string,
  description: typistJson.string,
})
var SolutionInstanceJson = typistJson.object({
  is_enabled: typistJson.boolean,
  last_job_id: typistJson.nullable(typistJson.string),
})
var JobJson = typistJson.object({
  id: typistJson.string,
  state: typistJson.any([
    typistJson.literal('running'),
    typistJson.literal('failure'),
    typistJson.literal('success'),
  ]),
  error_reason: typistJson.nullable(typistJson.string),
  started_at: typistJson.number,
  finished_at: typistJson.nullable(typistJson.number),
})
var ErrorCodeJson = typistJson.any([
  typistJson.literal('solution_not_found'),
  typistJson.literal('instance_not_found'),
  typistJson.literal('job_not_found'),
  typistJson.literal('invalid_token'),
  typistJson.literal('expired_token'),
  typistJson.literal('not_manual_trigger'),
  typistJson.literal('unknown'),
])
var ErrorJson = typistJson.object({
  error_code: ErrorCodeJson,
  error_message: typistJson.nullable(typistJson.string),
})

var ApiClientImpl = (function () {
  function ApiClientImpl(tokenManager, httpClient, apiRoot) {
    this.tokenManager = tokenManager
    this.httpClient = httpClient
    this.apiRoot = apiRoot
  }
  ApiClientImpl.prototype.getSolution = function (solutionId) {
    return __awaiter(this, void 0, void 0, function () {
      var url, json, error_1
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url =
              this.apiRoot + '/sdk/solutions/' + encodeURIComponent(solutionId)
            _a.label = 1
          case 1:
            _a.trys.push([1, 3, , 4])
            return [4, this.get(url)]
          case 2:
            json = _a.sent()
            if (!SolutionJson.check(json)) {
              throw new JsonError(json)
            }
            return [2, json]
          case 3:
            error_1 = _a.sent()
            if (
              error_1 instanceof ApiError &&
              error_1.errorCode === 'solution_not_found'
            ) {
              return [2, undefined]
            }
            throw error_1
          case 4:
            return [2]
        }
      })
    })
  }
  ApiClientImpl.prototype.enableSolutionInstance = function (solutionId) {
    return __awaiter(this, void 0, void 0, function () {
      var url
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url =
              this.apiRoot +
              '/sdk/solutions/' +
              encodeURIComponent(solutionId) +
              '/instance/enable'
            return [4, this.put(url, undefined)]
          case 1:
            _a.sent()
            return [2]
        }
      })
    })
  }
  ApiClientImpl.prototype.disableSolutionInstance = function (solutionId) {
    return __awaiter(this, void 0, void 0, function () {
      var url
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url =
              this.apiRoot +
              '/sdk/solutions/' +
              encodeURIComponent(solutionId) +
              '/instance/disable'
            return [4, this.put(url, undefined)]
          case 1:
            _a.sent()
            return [2]
        }
      })
    })
  }
  ApiClientImpl.prototype.getSolutionInstance = function (solutionId) {
    return __awaiter(this, void 0, void 0, function () {
      var url, json, error_2
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url =
              this.apiRoot +
              '/sdk/solutions/' +
              encodeURIComponent(solutionId) +
              '/instance'
            _a.label = 1
          case 1:
            _a.trys.push([1, 3, , 4])
            return [4, this.get(url)]
          case 2:
            json = _a.sent()
            if (!SolutionInstanceJson.check(json)) {
              throw new JsonError(json)
            }
            return [2, json]
          case 3:
            error_2 = _a.sent()
            if (
              error_2 instanceof ApiError &&
              error_2.errorCode === 'instance_not_found'
            ) {
              return [2, undefined]
            }
            throw error_2
          case 4:
            return [2]
        }
      })
    })
  }
  ApiClientImpl.prototype.runSolutionInstance = function (solutionId) {
    return __awaiter(this, void 0, void 0, function () {
      var url, json
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url =
              this.apiRoot +
              '/sdk/solutions/' +
              encodeURIComponent(solutionId) +
              '/instance/run'
            return [4, this.post(url, undefined)]
          case 1:
            json = _a.sent()
            if (!JobJson.check(json)) {
              throw new JsonError(json)
            }
            return [2, json]
        }
      })
    })
  }
  ApiClientImpl.prototype.getJob = function (jobId) {
    return __awaiter(this, void 0, void 0, function () {
      var url, json, error_3
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.apiRoot + '/sdk/jobs/' + encodeURIComponent(jobId)
            _a.label = 1
          case 1:
            _a.trys.push([1, 3, , 4])
            return [4, this.get(url)]
          case 2:
            json = _a.sent()
            if (!JobJson.check(json)) {
              throw new JsonError(json)
            }
            return [2, json]
          case 3:
            error_3 = _a.sent()
            if (
              error_3 instanceof ApiError &&
              error_3.errorCode === 'job_not_found'
            ) {
              return [2, undefined]
            }
            throw error_3
          case 4:
            return [2]
        }
      })
    })
  }
  ApiClientImpl.prototype.get = function (url) {
    return __awaiter(this, void 0, void 0, function () {
      var _a
      var _this = this
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this.retryOnTokenExpired
            return [4, this.tokenManager.getToken()]
          case 1:
            return [
              4,
              _a.apply(this, [
                _b.sent(),
                function (token) {
                  return _this.httpClient.get(url, token)
                },
              ]),
            ]
          case 2:
            return [2, _b.sent()]
        }
      })
    })
  }
  ApiClientImpl.prototype.post = function (url, body) {
    return __awaiter(this, void 0, void 0, function () {
      var _a
      var _this = this
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this.retryOnTokenExpired
            return [4, this.tokenManager.getToken()]
          case 1:
            return [
              4,
              _a.apply(this, [
                _b.sent(),
                function (token) {
                  return _this.httpClient.post(url, token, body)
                },
              ]),
            ]
          case 2:
            return [2, _b.sent()]
        }
      })
    })
  }
  ApiClientImpl.prototype.put = function (url, body) {
    return __awaiter(this, void 0, void 0, function () {
      var _a
      var _this = this
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this.retryOnTokenExpired
            return [4, this.tokenManager.getToken()]
          case 1:
            return [
              4,
              _a.apply(this, [
                _b.sent(),
                function (token) {
                  return _this.httpClient.put(url, token, body)
                },
              ]),
            ]
          case 2:
            return [2, _b.sent()]
        }
      })
    })
  }
  ApiClientImpl.prototype.retryOnTokenExpired = function (token, func) {
    return __awaiter(this, void 0, void 0, function () {
      var e_1, newToken, e_2
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2, , 8])
            return [4, func(token)]
          case 1:
            return [2, _a.sent()]
          case 2:
            e_1 = _a.sent()
            if (!(e_1 instanceof ApiError && e_1.errorCode === 'expired_token'))
              return [3, 7]
            return [4, this.tokenManager.getNewToken()]
          case 3:
            newToken = _a.sent()
            _a.label = 4
          case 4:
            _a.trys.push([4, 6, , 7])
            return [4, func(newToken)]
          case 5:
            return [2, _a.sent()]
          case 6:
            e_2 = _a.sent()
            if (e_2 instanceof ApiError && e_2.errorCode === 'expired_token') {
              throw new AnyflowError('refreshed_token_expired')
            }
            throw e_2
          case 7:
            throw e_1
          case 8:
            return [2]
        }
      })
    })
  }
  return ApiClientImpl
})()

var TokenManagerImpl = (function () {
  function TokenManagerImpl(tokenCreator) {
    this.tokenCreator = tokenCreator
  }
  TokenManagerImpl.prototype.getToken = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (this.token !== undefined) {
              return [2, this.token]
            }
            return [4, this.getNewToken()]
          case 1:
            return [2, _a.sent()]
        }
      })
    })
  }
  TokenManagerImpl.prototype.getNewToken = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _a
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _c.trys.push([0, 2, , 3])
            _a = this
            return [4, this.tokenCreator()]
          case 1:
            _a.token = _c.sent()
            return [2, this.token]
          case 2:
            _c.sent()
            throw new AnyflowError('token_creation_failed')
          case 3:
            return [2]
        }
      })
    })
  }
  return TokenManagerImpl
})()

var HttpClientImpl = (function () {
  function HttpClientImpl() {}
  HttpClientImpl.prototype.get = function (url, token) {
    return __awaiter(this, void 0, void 0, function () {
      var response, _a, _b
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [
              4,
              fetch(
                url,
                __assign({ method: 'GET' }, createBaseRequestInit(token))
              ),
            ]
          case 1:
            response = _c.sent()
            if (!!response.ok) return [3, 3]
            _a = throwError
            return [4, response.text()]
          case 2:
            _a.apply(void 0, [_c.sent(), response.status])
            _c.label = 3
          case 3:
            _b = parseJsonIgnoreError
            return [4, response.text()]
          case 4:
            return [2, _b.apply(void 0, [_c.sent()])]
        }
      })
    })
  }
  HttpClientImpl.prototype.post = function (url, token, body) {
    return __awaiter(this, void 0, void 0, function () {
      var response, _a, _b
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [
              4,
              fetch(
                url,
                __assign(
                  { method: 'POST', body: JSON.stringify(body) },
                  createBaseRequestInit(token)
                )
              ),
            ]
          case 1:
            response = _c.sent()
            if (!!response.ok) return [3, 3]
            _a = throwError
            return [4, response.text()]
          case 2:
            _a.apply(void 0, [_c.sent(), response.status])
            _c.label = 3
          case 3:
            _b = parseJsonIgnoreError
            return [4, response.text()]
          case 4:
            return [2, _b.apply(void 0, [_c.sent()])]
        }
      })
    })
  }
  HttpClientImpl.prototype.put = function (url, token, body) {
    return __awaiter(this, void 0, void 0, function () {
      var response, _a, _b
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [
              4,
              fetch(
                url,
                __assign(__assign({}, createBaseRequestInit(token)), {
                  method: 'PUT',
                  body: JSON.stringify(body),
                })
              ),
            ]
          case 1:
            response = _c.sent()
            if (!!response.ok) return [3, 3]
            _a = throwError
            return [4, response.text()]
          case 2:
            _a.apply(void 0, [_c.sent(), response.status])
            _c.label = 3
          case 3:
            _b = parseJsonIgnoreError
            return [4, response.text()]
          case 4:
            return [2, _b.apply(void 0, [_c.sent()])]
        }
      })
    })
  }
  return HttpClientImpl
})()
function createBaseRequestInit(token) {
  return {
    mode: 'cors',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  }
}
function throwError(responseBody, responseStatusCode) {
  var _a
  var json = parseJsonIgnoreError(responseBody)
  if (ErrorJson.check(json)) {
    throw new ApiError(
      json.error_code,
      (_a = json.error_message) !== null && _a !== void 0 ? _a : undefined
    )
  }
  throw new HttpError(responseStatusCode, responseBody)
}
function parseJsonIgnoreError(body) {
  try {
    return JSON.parse(body)
  } catch (ignore) {
    return undefined
  }
}

var Config = {
  apiRoot: 'https://for-product-api.anyflow.jp',
  wizardRoot: 'https://wizard.anyflow.jp',
}
var WizardTokenRefreshHandler = (function () {
  function WizardTokenRefreshHandler(tokenManager, wizardOrigin) {
    var _this = this
    this.handler = function (e) {
      if (e.origin !== _this.wizardOrigin) {
        return
      }
      if (TokenRefreshRequestMessageChecker.check(e.data)) {
        _this.tokenManager
          .getNewToken()
          .then(function (newToken) {
            var message = {
              type: 'token_refresh_success',
              token: newToken,
            }
            if (e.source !== null) {
              try {
                e.source.postMessage(message, _this.wizardOrigin)
              } catch (error) {}
            }
          })
          .catch(function () {
            var message = {
              type: 'token_refresh_failure',
            }
            if (e.source !== null) {
              try {
                e.source.postMessage(message, _this.wizardOrigin)
              } catch (error) {}
            }
          })
      }
    }
    this.tokenManager = tokenManager
    this.wizardOrigin = wizardOrigin
  }
  WizardTokenRefreshHandler.prototype.attach = function (window) {
    if (this.attachedWindow) {
      return
    }
    window.addEventListener('message', this.handler)
    this.attachedWindow = window
  }
  WizardTokenRefreshHandler.prototype.detach = function () {
    if (!this.attachedWindow) {
      return
    }
    this.attachedWindow.removeEventListener('message', this.handler)
    this.attachedWindow = undefined
  }
  return WizardTokenRefreshHandler
})()
var TokenRefreshRequestMessageChecker = typistJson.object({
  type: typistJson.literal('token_refresh_request'),
})

var instance
var AnyflowSDK = {
  init: function (tokenCreator) {
    if (instance !== undefined) {
      throw new AnyflowError('sdk_already_initialized')
    }
    var tokenManager = new TokenManagerImpl(tokenCreator)
    var wizardTokenRefreshHandler = new WizardTokenRefreshHandler(
      tokenManager,
      new URL(Config.wizardRoot).origin
    )
    if (typeof window !== 'undefined') {
      wizardTokenRefreshHandler.attach(window)
    }
    var apiClient = new ApiClientImpl(
      tokenManager,
      new HttpClientImpl(),
      Config.apiRoot
    )
    var sdk = new AnyflowSDKImpl(apiClient, tokenManager, Config.wizardRoot)
    instance = {
      sdk: sdk,
      wizardTokenRefreshHandler: wizardTokenRefreshHandler,
    }
    return sdk
  },
  get instance() {
    if (instance === undefined) {
      throw new AnyflowError('sdk_not_initialized')
    }
    return instance.sdk
  },
  get isInitialized() {
    return instance !== undefined
  },
  destroy: function () {
    instance === null || instance === void 0
      ? void 0
      : instance.wizardTokenRefreshHandler.detach()
    instance === null || instance === void 0 ? void 0 : instance.sdk.destroy()
    instance = undefined
  },
}

export { AnyflowError, AnyflowSDK }
